import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ICrossTalk, Status } from 'interfaces'
import axiosClient from 'utils/axiosClient'

const initialState: {
  list: ICrossTalk[]
  status: Status
} = {
  list: [],
  status: 'init',
}

export const getCrossTalks = createAsyncThunk(
  'CrossTalk/getCrossTalks',
  async () => {
    const { data } = await axiosClient.get<ICrossTalk[]>(
      '/api/crosstalk?all=true'
    )
    return data
  }
)
export const getCrossTalk = createAsyncThunk(
  'CrossTalk/getCrossTalk',
  async (_id: string) => {
    const { data } = await axiosClient.get<ICrossTalk>('/api/crosstalk/' + _id)
    return data
  }
)

const CrossTalkSlice = createSlice({
  name: 'CrossTalk',
  initialState,
  reducers: {
    deleteItem(state, { payload }: PayloadAction<string>) {
      if (state.list) {
        const index = state.list.findIndex((f) => f._id === payload)
        if (index >= 0) {
          state.list.splice(index, 1)
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCrossTalks.pending, (state) => {
      state.status = 'pending'
    })
    builder.addCase(getCrossTalks.rejected, (state) => {
      state.status = 'rejected'
    })
    builder.addCase(getCrossTalks.fulfilled, (state, { payload }) => {
      state.list = payload
      state.status = 'fulfilled'
    })
    builder.addCase(getCrossTalk.fulfilled, (state, { payload }) => {
      const index = state.list.findIndex((f) => f._id === payload._id)
      if (index >= 0) {
        state.list.splice(index, 1, payload)
      } else {
        state.list.push(payload)
      }
    })
  },
})

export const CrossTalkAction = CrossTalkSlice.actions

export const CrossTalkReducer = CrossTalkSlice.reducer
